"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSimpleDropdown = void 0;
var React = require("react");
var ApSimpleDropdownLabel_1 = require("./ApSimpleDropdownLabel");
var ApMenu_1 = require("../ApMenu");
var ApSimpleDropdown_styles_1 = require("./ApSimpleDropdown.styles");
var DEFAULT_LABEL = 'Select an option';
exports.ApSimpleDropdown = function (_a) {
    var options = _a.options, selected = _a.selected, iconName = _a.iconName, iconProps = _a.iconProps, disabled = _a.disabled, onChange = _a.onChange, label = _a.label, multiple = _a.multiple, message = _a.message, maxItems = _a.maxItems;
    var selectedOptionsCount = Array.isArray(selected) ? selected.length : 1;
    var maxItemsExceeded = !!maxItems && selectedOptionsCount >= maxItems;
    var getCheckIcon = function (value) {
        var checked = false;
        if (selected) {
            if (Array.isArray(selected)) {
                var valueIndex = selected.findIndex(function (option) { return option.value === value; });
                checked = -1 !== valueIndex && selected[valueIndex].value === value;
            }
            else {
                checked = selected.value === value;
            }
        }
        return checked;
    };
    var getSelectedLabel = function () {
        if (selected) {
            if (Array.isArray(selected)) {
                return (selected.map(function (option) { return option.label; }).join(', ') ||
                    DEFAULT_LABEL);
            }
            else {
                return selected.label;
            }
        }
        return DEFAULT_LABEL;
    };
    var handleOptionSelect = function (newSelectedOption) {
        if (multiple) {
            if (selected) {
                var newSelected = Array.isArray(selected) ? __spread(selected) : [selected];
                var index = newSelected.findIndex(function (option) { return option.value === newSelectedOption.value; });
                if (-1 !== index) {
                    newSelected.splice(index, 1);
                }
                else if (!maxItemsExceeded) {
                    newSelected.push(newSelectedOption);
                }
                onChange(newSelected);
            }
            else {
                onChange([newSelectedOption]);
            }
        }
        else {
            onChange(newSelectedOption);
        }
    };
    var ItemComponent = multiple ? ApMenu_1.ApMenuItemMultiSelect : ApMenu_1.ApMenuItemSelect;
    return (React.createElement(ApSimpleDropdown_styles_1.ApMenuStyled, { placement: "bottom-start", button: function (props) { return (React.createElement(ApSimpleDropdownLabel_1.default, __assign({}, props, { text: label || getSelectedLabel(), iconName: iconName, iconProps: iconProps, disabled: disabled }))); } },
        message && React.createElement(ApSimpleDropdown_styles_1.MessageWrapper, null, message),
        options.map(function (option) { return (React.createElement(ItemComponent, { key: option.label + "-" + option.value, onClick: function () { return handleOptionSelect(option); }, disabled: option.disabled, selected: getCheckIcon(option.value) }, option.labelNode || option.label)); })));
};
exports.default = exports.ApSimpleDropdown;
//# sourceMappingURL=ApSimpleDropdown.js.map